// Modules
import React, { ReactChild } from 'react'
import { Button } from '@dasa-health/components-react'

// Applicationm
import Logo from 'assets/logo.svg'

// Component
import { ContainerGlobal, Container, Content, Header, Illustration } from './styles'

interface Props {
    children: ReactChild
    image: string
    goTo: () => void
    title: string
    titleType: string
    buttonText: string
    imageAlt: string
}

export const TemplateContainerFullWidth: React.FC<Props> = props => {
    const { children, image, goTo, title, buttonText, imageAlt, titleType } = props
    return (
        <ContainerGlobal>
            <Header>
                <img alt="NAV" className="header__image" src={Logo} />
            </Header>
            <Container>
                <Content>
                    <Illustration alt={imageAlt} data-testid="content-illustration" src={image} />
                    <h1 className={`title__${titleType}`}>{title}</h1>
                    {children}
                    <Button
                        data-testid="content-button"
                        fullWidth={true}
                        onClick={goTo}
                        size="default"
                        type="button"
                        variant="primary"
                    >
                        {buttonText}
                    </Button>
                </Content>
            </Container>
        </ContainerGlobal>
    )
}
